/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Leave_OwnerInputs */

const en_us2_clubs_leave_owner = /** @type {(inputs: Clubs_Leave_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you leave, the club passes to whoever has been in it longest, an admin first.`)
};

const pt_br2_clubs_leave_owner = /** @type {(inputs: Clubs_Leave_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se você sair, o clube passa para quem está nele há mais tempo, um admin primeiro.`)
};

const es_419_clubs_leave_owner = /** @type {(inputs: Clubs_Leave_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si sales, el club pasa a quien lleve más tiempo en él, primero un admin.`)
};

const pt_pt2_clubs_leave_owner = /** @type {(inputs: Clubs_Leave_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se saíres, o clube passa para quem lá está há mais tempo, primeiro um admin.`)
};

const fr_fr2_clubs_leave_owner = /** @type {(inputs: Clubs_Leave_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si tu pars, le club revient au membre le plus ancien, un admin en priorité.`)
};

const de_de2_clubs_leave_owner = /** @type {(inputs: Clubs_Leave_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn du gehst, geht der Club an die Person, die am längsten dabei ist, zuerst an einen Admin.`)
};

const it_it2_clubs_leave_owner = /** @type {(inputs: Clubs_Leave_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se esci, il club passa a chi ci è da più tempo, prima a un admin.`)
};

/**
* | output |
* | --- |
* | "If you leave, the club passes to whoever has been in it longest, an admin first." |
*
* @param {Clubs_Leave_OwnerInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_leave_owner = /** @type {((inputs?: Clubs_Leave_OwnerInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Leave_OwnerInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_leave_owner(inputs)
	if (locale === "es-419") return es_419_clubs_leave_owner(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_leave_owner(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_leave_owner(inputs)
	if (locale === "de-DE") return de_de2_clubs_leave_owner(inputs)
	if (locale === "it-IT") return it_it2_clubs_leave_owner(inputs)
	return en_us2_clubs_leave_owner(inputs)
});
export { clubs_leave_owner as "clubs.leave_owner" }